import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Spinner from '@salesforce/design-system-react/components/spinner';
import Button from '@salesforce/design-system-react/components/button';
import { useApolloClient } from '@apollo/react-hooks';
import { GET_MATERIAL_VARIANT } from '../../../graphql/getMaterialVariant';
import './index.scss';
import { getUserInfo } from '../../../store/ducks/userInfo';
import { MATARIAL_VARIANT_BU } from '../../../util/constants';

const MaterialVariant = (product: any) => {
  const userInfo = useSelector(getUserInfo);
  const allowedBU = MATARIAL_VARIANT_BU.includes((userInfo && userInfo.businessunit) || '');
  const part = product?.item;
  const isMaterialVariant = part?.value?.[0]?.hasMaterialVariant || part?.hasMaterialVariant;
  const client = useApolloClient();
  const [materialValriant, setMaterialValriant] = useState([]);
  const [isMvOpen, setIsMvOpen] = useState(false);
  const [loader, setLoader] = useState(false);

  const getMvData = async () => {
    const productId = part?.value?.[0]?.productId || part?.productId;
    setLoader(true);
    const materialVariantResponse: any = await client.query({
      query: GET_MATERIAL_VARIANT,
      variables: {
        productId,
      },
    });
    setLoader(false);
    const materialData = materialVariantResponse.data.getMaterialVariant;
    if (materialData) {
      setIsMvOpen(true);
      setMaterialValriant(materialData);
    }
  };

  return (
    <>
      {isMaterialVariant && allowedBU && (
        <Button
          label="View Material Variant(s)"
          className="mvBtn"
          onClick={() => {
            if (isMvOpen) {
              setIsMvOpen(false);
            } else {
              getMvData();
            }
          }}
          variant="base"
        />
      )}
      {loader && <Spinner size="small" />}
      {isMvOpen && (
        <div className="material-variant-main-container">
          <div className="material-variant-table-container">
            <div className="material-variant-header mvp-cols">
              <p style={{ paddingLeft: '5px' }}>Options Type</p>
              <p style={{ paddingLeft: '5px' }}>Text</p>
            </div>
            {materialValriant?.length > 0 &&
              materialValriant.map((mv: any) => {
                return (
                  <div className="material-variant-body mvp-cols">
                    <div className="tableBody">{mv.variantOptionType}</div>
                    <div className="tableBody">{mv.description}</div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </>
  );
};

export default MaterialVariant;
